import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormControl, FormsModule, Validators} from '@angular/forms';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { QuizService } from 'src/app/shared-service/services/quiz.service';
import { Subject } from 'rxjs';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';
import { AppConfig } from 'src/app/app.config';
//import { AppComponent } from './app.component';

// @NgModule({
//   declarations: [
//     CreateDiscussModalComponent
//   ],
//   imports: [
//     BrowserModule,
//     FormsModule
//   ],
//   providers: [],
//   bootstrap: [CreateDiscussModalComponent]
// })

@Component({
  selector: 'app-create-discuss-modal',
  templateUrl: './create-discuss-modal.component.html',
  styleUrls: ['./create-discuss-modal.component.css']
})
export class CreateDiscussModalComponent implements OnInit {

  // bsModalRef: BsModalRef;
  // postTitle: string = "";
  // postText: string = "";
  postQuestion: string = "";
  exams:any;
  subjectData:any;

  examData:any;
  filterExamData:any;
  examSearchCtrl = new FormControl();
  selectedSubject: string;
  selectedExamtabId: string='0';
  mcqForm: FormGroup;
  answerArrayItems: {
    id: string;
    title: string;
  }[];
  optionArrayItems: {
    optionId: string;
    optionTitle: string;
  }[];

  closeResult = '';

  forum_files = [];
  form_file_path: string='';
  fileToUpload: File = null;
  section1Submit = false;
  section2Submit = false;
  section3Submit = false;

  section1_form: FormGroup;
  section2_form: FormGroup;
  selectedOption=0;
  currentActiveTab: string = 'simple';
  fileName: string;
  imageSrc: string;
  userData:any;
  user_id='';
  currentUrl:any;
  supportText = 'Uploaded image format is not supported, please upload png/jpg/jpeg format images';
  showSupportText = false;
  isSubmit =false;

  baseUrl = '';
  rootUrl = '';
  discussUrl ='';
  playstoreLink = '';
  phoneNo = '';
  address = '';
  emailId = '';
  isdCode = '';
  domain = '';
  titleName ='';


  public onHide: Subject<any> = new Subject<any>();

  constructor(
    public bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder,
    private discussionService: DiscussionService,
    private quizService: QuizService,
    public modalConfig: NgbModalConfig,
    private config: AppConfig
    ) {
      this.baseUrl = this.config.getConfig('DISCUSS_BASE_URL');
      this.rootUrl = this.config.getConfig('DISCUSS_API_URL');
      this.discussUrl =this.config.getConfig('DISCUSS_ROOT_URL');
      this.playstoreLink =  this.config.getConfig('MOBILE_PLAYSTORE_URL');
      this.phoneNo =  this.config.getConfig('PHONE_NO');
      this.address =  this.config.getConfig('ADDRESS');
      this.emailId =  this.config.getConfig('EMAIL_ID');
      this.isdCode = this.config.getConfig('PHONE_ISD_CODE');
      this.domain = this.config.getConfig('DOMAIN');
      this.titleName =this.config.getConfig('TITLE');
      modalConfig.backdrop = 'static';
      modalConfig.keyboard = false;
      this.section1_form = this._formBuilder.group({'postTitle': ['', Validators.required], 'postDescription': ['']});
      this.section2_form = this._formBuilder.group({'postTitle': ['', Validators.required]});

    this.mcqForm = this._formBuilder.group({
      answerReturnArray: this._formBuilder.array([
        '',
        ''
      ]),
      optionReturnArray: this._formBuilder.array([
        {"optionId":'option_radio_id_1',"optionTitle":'OP_1'},
        {"optionId":'option_radio_id_2',"optionTitle":'OP_2'}
      ])
    },
    );

  }

  get answerReturnArray() {
    return this.mcqForm.get('answerReturnArray') as FormArray;
  }

  get optionReturnArray() {
    return this.mcqForm.get('optionReturnArray') as FormArray;
  }

  tabChangePostMCQ(activeTab) {
    this.currentActiveTab = activeTab;
  }

  optionClicked(opt) {
    this.selectedOption = opt;
  }

  addItem() {
    console.log(this.answerReturnArray);
    console.log(this.optionReturnArray);
   if(this.answerReturnArray.length == 5) {
      document.getElementById('option-error-msg').style.display = "block";
      setTimeout(() => {
        document.getElementById('option-error-msg').style.display = "none";
      }, 3000);
    } else {
      let i = 'answer_text_id_'+(this.answerReturnArray.length+1);
      let t = 'OP_'+(this.answerReturnArray.length+1);
      this.answerArrayItems.push({"id":i,"title":t});
      this.answerReturnArray.push(this._formBuilder.control(''));

      let o = 'option_radio_id_'+(this.optionReturnArray.length+1);
      let op = 'OP_'+(this.optionReturnArray.length+1);
      this.optionArrayItems.push({"optionId":o,"optionTitle":op});
      this.optionReturnArray.push(this._formBuilder.control(''));
    }
  }
  removeItem() {
    if(this.answerReturnArray.length == 0) {
      document.getElementById('option-error-empty-msg').style.display = "block";
      setTimeout(() => {
        document.getElementById('option-error-empty-msg').style.display = "none";
      }, 3000);
    }else {
      if(this.selectedOption == this.answerReturnArray.length) {
        this.selectedOption=0;
      }
      this.answerArrayItems.pop();
      this.answerReturnArray.removeAt(this.answerReturnArray.length - 1);

      this.optionArrayItems.pop();
      this.optionReturnArray.removeAt(this.optionReturnArray.length - 1);
    }
  }

  ngOnInit() {
    this.quizService.clearTestCacheData();
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.user_id = this.userData.user_id;
    }
    this.getSubjects();
    this.getExamsWithSubExams();
    this.answerArrayItems = [
      {"id":'answer_text_id_1',title:'OP_1'},
      {"id":'answer_text_id_2',title:'OP_2'}
    ];
    this.optionArrayItems = [
      {"optionId":'option_radio_id_1',"optionTitle":'OP_1'},
      {"optionId":'option_radio_id_2',"optionTitle":'OP_2'}
    ];


    document.getElementById('create-exam-modal-header').style.display = "none";
    document.getElementById('create-exam-modal-body').style.display = "none";

    document.getElementById('create-subject-modal-header').style.display = "none";
    document.getElementById('create-subject-modal-body').style.display = "none";
  }


  markFormTouched(group: FormGroup | FormArray) {
    Object.keys(group.controls).forEach((key: string) => {
      const control = group.controls[key];
      if (control instanceof FormGroup || control instanceof FormArray) { control.markAsTouched(); this.markFormTouched(control); }
      else { control.markAsTouched(); };
    });
  };

  open(content) {
    if(this.currentActiveTab == 'simple') {
     // this.section2_form.value.postTitle = '';
      this.section2_form.get("postTitle").setValue("");
    } else {
      this.section1_form.get("postTitle").setValue("");
    //  this.section1_form.value.postTitle = '';
    }
    if(content==='section1'){
      this.markFormTouched(this.section1_form);
      this.markFormTouched(this.section2_form);
      document.getElementById('error-msg-subject').style.display = "none";
      document.getElementById('error-msg-exam').style.display = "none";
      if(this.section1_form.valid || this.section2_form.valid) {
        document.getElementById('create-discuss-modal-header').parentElement.style.display = "block";
        document.getElementById('create-discuss-modal-header').style.display = "block";
        document.getElementById('create-discuss-modal-body').style.display = "block";

        document.getElementById('create-exam-modal-header').parentElement.style.display = "none";
        document.getElementById('create-exam-modal-header').style.display = "none";
        document.getElementById('create-exam-modal-body').style.display = "none";

        document.getElementById('create-subject-modal-header').parentElement.style.display = "none";
        document.getElementById('create-subject-modal-header').style.display = "none";
        document.getElementById('create-subject-modal-body').style.display = "none";
      } else {

      }

    }
    else if (content==='section2'){
      document.getElementById('error-msg-subject').style.display = "none";
      document.getElementById('error-msg-exam').style.display = "none";
      // add a check answerArrayItems length
      this.markFormTouched(this.section1_form);
      this.markFormTouched(this.section2_form);
      if(this.section1_form.valid || this.section2_form.valid) {
        document.getElementById('create-discuss-modal-header').parentElement.style.display = "none";
        document.getElementById('create-discuss-modal-header').style.display = "none";
        document.getElementById('create-discuss-modal-body').style.display = "none";

        document.getElementById('create-exam-modal-header').parentElement.style.display = "block";
        document.getElementById('create-exam-modal-header').style.display = "block";
        document.getElementById('create-exam-modal-body').style.display = "block";

        document.getElementById('create-subject-modal-header').style.display = "none";
        document.getElementById('create-subject-modal-body').style.display = "none";
        document.getElementById('create-subject-modal-header').parentElement.style.display = "none";
      }
    }
    else if (content==='section3'){
      document.getElementById('error-msg-subject').style.display = "none";
      document.getElementById('error-msg-exam').style.display = "none";
      let isExamChecked = false;
      this.filterExamData.forEach(category => {
        if(!isExamChecked) {
          category.sub_category.forEach(subCategory => {
            if(subCategory.isChecked) {
              isExamChecked = true;
            }
          });
        }
      });
      if(isExamChecked) {
        document.getElementById('create-discuss-modal-header').parentElement.style.display = "none";
        document.getElementById('create-discuss-modal-header').style.display = "none";
        document.getElementById('create-discuss-modal-body').style.display = "none";

        document.getElementById('create-exam-modal-header').parentElement.style.display = "none";
        document.getElementById('create-exam-modal-header').style.display = "none";
        document.getElementById('create-exam-modal-body').style.display = "none";

        document.getElementById('create-subject-modal-header').parentElement.style.display = "block";
        document.getElementById('create-subject-modal-header').style.display = "block";
        document.getElementById('create-subject-modal-body').style.display = "block";
      } else {
        document.getElementById('error-msg-exam').style.display = "block";
        setTimeout(() => {
          document.getElementById('error-msg-exam').style.display = "none";
        }, 3000);
      }
    }
    else if (content==='submit') {
      if(this.selectedSubject) {
        document.getElementById('error-msg-subject').style.display = "none";
        this.saveDiscussForm();
      } else {
        document.getElementById('error-msg-subject').style.display = "block";
        setTimeout(() => {
          document.getElementById('error-msg-subject').style.display = "none";
        }, 3000);
      }
    }


  }

  fileChangeEvent(fileInput: any) {
    // currently not using this method - base64 image
    var me = this;
    if (fileInput.target.files && fileInput.target.files[0]) {
        // Size Filter Bytes
        const max_size = 20971520;
        const allowed_types = ['image/png', 'image/jpeg'];
        const max_height = 15200;
        const max_width = 25600;

        if (fileInput.target.files[0].size > max_size) {
            return false;
        }

        if (!allowed_types.includes(fileInput.target.files[0].type)) {
            return false;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const image = new Image();
            image.src = e.target.result;
            image.onload = rs => {
                const img_height = rs.currentTarget['height'];
                const img_width = rs.currentTarget['width'];

                console.log(img_height, img_width);


                if (img_height > max_height && img_width > max_width) {
                    return false;
                } else {
                    const imgBase64Path = e.target.result;
                    me.forum_files.push(imgBase64Path);
                }
            };
        };
        reader.readAsDataURL(fileInput.target.files[0]);
    }
}

fileChangeEventUpload(files: FileList){
  const allowed_types = ['image/png','image/jpg','image/jpeg'];
  let fileType =  files.item(0).type;
  if(allowed_types.includes(fileType)) {
    this.showSupportText = false;
    this.fileToUpload = files.item(0);
    this.fileName = this.fileToUpload.name;
    this.setpreviewImage();
  } else {
    this.showSupportText = true;
  }
}

removeFile() {
  this.fileName = '';
}

  saveDiscussForm() {
    console.log(this);
    this.isSubmit = true;
    let exams_list = [];
    this.filterExamData.forEach(mainCat => {
        mainCat.sub_category.forEach(subCat => {
          if(subCat.isChecked) {
            exams_list.push({
              "main_category_id":mainCat.main_cat_id,
              "category_id": subCat.id
            })
          }
        })
    });

    const formData = new FormData();
    let data = {
      'user_id': this.user_id,
      'forum_description': this.currentActiveTab == 'simple' ?  this.section1_form.value.postDescription: this.postQuestion,
      'forum_title': this.currentActiveTab == 'simple' ? this.section1_form.value.postTitle : this.section2_form.value.postTitle,
      'forum_type': this.currentActiveTab,
      'forum_mcq_choices':this.currentActiveTab == 'simple' ? '': this.mcqForm.value.answerReturnArray,
      'forum_mcq_answers': this.currentActiveTab == 'simple' ? '': this.selectedOption,
      'forum_points':'',
      'forum_subject_id': this.selectedSubject,
      'forum_tag_id':'',
      'forum_exam_ids':exams_list,
      'forum_device':'web',
      'forum_file': this.fileToUpload,
    };

    formData.append('user_id', data['user_id']);
    formData.append('forum_description', data['forum_description']);
    formData.append('forum_title', data['forum_title']);
    formData.append('forum_type', data['forum_type']);
    formData.append('forum_mcq_choices', data['forum_mcq_choices']);
    formData.append('forum_mcq_answers', JSON.stringify(data['forum_mcq_answers']));
    formData.append('forum_points', data['forum_points']);
    formData.append('forum_subject_id', data['forum_subject_id']);
    formData.append('forum_tag_id', data['forum_tag_id']);
    formData.append('forum_exam_ids', JSON.stringify(data['forum_exam_ids']));
    formData.append('forum_device', data['forum_device']);
    formData.append('forum_file', data['forum_file']);
    this.discussionService.saveDiscussForm(formData).subscribe((result:any) => {
      if(result && result.state == 200) {
        this.discussionService.newPostRefresh.next(true);
        this.closeModal();
      } else {
        // show error message
        this.discussionService.newPostRefresh.next(false);
        this.isSubmit = false;
      }
    })
  }
  closeModal(){
  //  this.onHide.next(true);
    this.bsModalRef.hide();
  }
  setpreviewImage() {
    const reader = new FileReader();
    reader.readAsDataURL(this.fileToUpload);
    reader.onload = () => {
      this.imageSrc = reader.result as string;
    };
  }

  getSubjects(){
    this.discussionService.getSubjects().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.subjectData = res.data;
        }
      }
    )
  }

  getExamsWithSubExams(){
    this.discussionService.getExamsWithSubExams().subscribe(
      (res:any) => {
        if(res.state === 200){
          this.examData = res.data;
          this.filterExamData = res.data;
        }
      }
    )
  }

  applyFilterExam(event:Event) {
    this.filterExamTabList();
    this.filterExamData.forEach(exam => {
      exam.sub_category = exam.sub_category.filter(examSubCat => {
        return examSubCat.category_name.toLowerCase().indexOf(this.examSearchCtrl.value.toLowerCase()) != -1;
      });
    });

  }

  setExamMainCat(main_cat_id) {
    this.examSearchCtrl.patchValue('');
    this.selectedExamtabId = main_cat_id;
    this.filterExamData.forEach(exam => {
      exam.sub_category.forEach(examSubCat => {
        examSubCat.isChecked = false;
      });
    });
    this.filterExamTabList();
  }

  filterExamTabList() {
    if(this.selectedExamtabId == '0') {
      this.filterExamData = JSON.parse(JSON.stringify(this.examData));
    } else {
      this.filterExamData = JSON.parse(JSON.stringify(this.examData));
      this.filterExamData = this.filterExamData.filter(exam => {
        return exam.main_cat_id == this.selectedExamtabId;
      });
    }
  }
}

